<template>
  <div style="display:inline-block;">
    <el-autocomplete
      v-model="unitQuery"
      size="medium"
      :trigger-on-focus="false"
      value-key="name"
      :fetch-suggestions="querySearchAsync"
      placeholder="请输入用工单位"
      @select="handleSelect"
    />
  </div>
</template>
<script>
import { unitService } from '@/api/index'
import { checkName } from '@/tool/utils'

export default {
  name: 'UnitSearch',
  data() {
    return {
      restaurants: [],
      // 输入关键字
      unitQuery: null,
      currentUnitId: null,
    }
  },

  watch: {
    unitQuery(newval) {
      if (!newval) {
        this.currentUnitId = null
        // this.$emit('submitUnitId', this.currentUnitId)
      }
    },
    currentUnitId() {
      this.$emit('submitUnitId', this.currentUnitId)
    },
  },
  mounted() {
    if (this.$route.params.id && this.$route.params.name) {
      this.unitQuery = this.$route.params.name
      this.currentUnitId = this.$route.params.id
    } else {
      this.unitQuery = null
      this.currentUnitId = null
    }
  },
  methods: {
    querySearchAsync(queryString, cb) {
      const _this = this
      if (!checkName(queryString)) {
        unitService()._queryUnitByName(_this.unitQuery).then(res => {
          _this.restaurants = []
          if (res.status && res.data.length !== 0) {
            _this.restaurants.push(...res.data)
            cb(_this.restaurants)
          } else {
            this.currentUnitId = null
            cb(_this.restaurants)
          }
        })
      } else {
        _this.$message.warning('请不要输入特殊字符')
        _this.unitQuery = ''
        _this.restaurants = []
        _this.currentUnitId = null
        cb(_this.restaurants)
      }
    },
    handleSelect(item) {
      this.currentUnitId = item.id
      this.$emit('submitUnitId', item.id)
      this.$emit('submitName', this.unitQuery)
    },
  },
}
</script>
